'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createInstance = undefined;

var _connectors = require('./connectors');

var _analytics = require('./analytics');

var createInstance = exports.createInstance = function createInstance() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      sendGa4Ecommerce = _ref.sendGa4Ecommerce,
      sendInHouseAnalytics = _ref.sendInHouseAnalytics;

  return (0, _analytics.analyticsFactory)((0, _connectors.getConnectors)({ sendInHouseAnalytics: sendInHouseAnalytics }), {
    sendGa4Ecommerce: sendGa4Ecommerce
  });
};

exports.default = Object.assign({}, createInstance(), {
  createInstance: createInstance
});
//# sourceMappingURL=index.js.map